import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not authed
  const [dealership, setDealership] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("xpro_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data.user); setDealership(r.data.dealership); })
      .catch(() => { localStorage.removeItem("xpro_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("xpro_token", data.access_token);
    setUser(data.user); setDealership(data.dealership);
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("xpro_token", data.access_token);
    setUser(data.user); setDealership(data.dealership);
  };

  const logout = () => {
    localStorage.removeItem("xpro_token");
    setUser(false); setDealership(null);
  };

  const refreshDealership = async () => {
    const { data } = await api.get("/dealership");
    setDealership(data);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setDealership(data.dealership);
    } catch { /* noop */ }
  };

  return (
    <AuthContext.Provider value={{ user, dealership, login, signup, logout, refreshDealership, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
